<div class=" modalAdd " id="viewConfigureEodReportModal" role="dialog">
    <div class="add_another_waste_modal waste_popup_modal">
        <div class="">
            <div class="modal-content ConfigureEodReportModal">
                <div class="modal-header">
                    <label class="modal-title">Configure EOD Alert Email</label>
                    <img src="assets/images/close.svg" class="close" ng-click="vm.hideEodReportConfig()" alt="close"
                        mat-dialog-close>
                </div>
                <div class="waste_modal_content cf nopadding">
                    <div class="padng_lft_rght">
                        <div class="cf ">
                            <div class="email_on_off">
                                <br>
                                <div><label>Email Alerts</label><span class="req_star">*</span></div>
                                <div class="m_t15">
                                    <span>
                                        <img src="{{(eodConfig.alertOn)?'assets/images/radio_button/Checked.svg':'assets/images/radio_button/Default.svg'}}"
                                            (click)="toggleEodAlertConfig();reset()" class="w_16" alt="radio">

                                        On</span>&nbsp;&nbsp;
                                    <span>
                                        <img src="{{(!eodConfig.alertOn)?'assets/images/radio_button/Checked.svg':'assets/images/radio_button/Default.svg'}}"
                                            (click)="toggleEodAlertConfig();reset()" class="w_16" alt=" radio">

                                        Off</span>
                                </div>
                            </div>
                            <br>
                        </div>
                        <div class="cf mb_15">
                            <div><label>Email Recipients</label><span class="req_star">*</span></div>
                            <div [ngClass]="{errorborder:eodConfig.errors.indexOf('selectedRecipients') > -1}"
                                class="add_alert_multiselect">
                                <ng-select name="" [items]="eodConfig.recipients" [multiple]="true" bindLabel="fullName"
                                    class="select_recipient" id="recipient" [(ngModel)]="eodConfig.selectedRecipients"
                                    groupBy="account" style="position: relative" placeholder="-Select Recipients-"
                                    [selectableGroup]="true" (change)="revalidate('selectedRecipients')"
                                    [selectableGroupAsModel]="false" [closeOnSelect]="false" [clearSearchOnAdd]="true"
                                    bindValue="" [editableSearchTerm]="true">

                                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                        <input id="item-{{index}}" type="checkbox" [ngModelOptions]="{standalone: true}"
                                            [checked]="item$.selected" /> {{item.fullName}}
                                    </ng-template>
                                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                        <div class="ng-value" *ngFor="let item of items | slice:0:1">
                                            <span class="ng-value-label">{{item.fullName}}</span>
                                        </div>
                                        <div class="ng-value" *ngIf="eodConfig.selectedRecipients.length > 3">
                                            <span class="ng-value-label">{{eodConfig.selectedRecipients.length }}
                                                selected</span>
                                        </div>
                                    </ng-template>
                                    <!-- <ng-template ng-header-tmp>
                                        <input id="recipient1" #recipient1 autofocus style="width: 100%; line-height: 24px"
                                            type="text" (input)="recipient.filter($event.target.value)" />
                                    </ng-template> -->

                                </ng-select>
                            </div>
                            <div class="errorMessage" *ngIf="eodConfig.errors.indexOf('selectedRecipients') > -1 ">
                                Recipient
                                is required
                            </div>
                        </div>
                        <div class="new_alert_date">
                            <div><label>Alert Time</label><span class="req_star">*</span></div>
                            <div class="">
                                <input type="time" id="exampleInput" name="input" [(ngModel)]="eodConfig.dateTime"
                                    placeholder="HH:mm" />
                                    <!-- (change)="changeDate()" -->
                               
                                <div class="errorMessage" *ngIf="eodConfig.errors.indexOf('dateTime')>-1">Alert
                                    time is required</div>
                                <div class="errorMessage" *ngIf="eodConfig.dateTimeError">Alert time is invalid</div>
                                <!-- <div class="errorMessage"[hidden]="eodConfig.dateTimeInput">Alert time is invalid
                                </div> -->
                            </div>
                        </div>
                        <br>
                        <div class="config_eod_alert_days mb_15 alert_align">
                            <div><label>Alert Days</label><span class="req_star">*</span></div>
                            <div>
                                <span *ngFor="let day of data.daysOfWeek">
                                    <img alt="checkboxes"
                                        src="{{(isDayOfWeekSelected(day.id))?'./assets/images/check_box_selected.svg':'./assets/images/check_box_unselected.png'}}"
                                        (click)="toggleDayOfWeek(day.id)" class="w_14">
                                    {{day.value}}
                                </span>
                            </div>
                            <div id="error-div2" class="error_format"
                                *ngIf="eodConfig.errors.indexOf('weeklyFrequency')>-1">At
                                least one day should be selected
                            </div>
                        </div>

                        <div class="m_t80 noborder shipment_content_modal_btns pull-right display_flx cf">
                            <div class="prim-button-link height_30px w_165 flt_right" data-dismiss="modal"
                                (click)="saveEodConfig()">SAVE</div>
                            <div class="empty_span flt_right w_90 ">&nbsp;</div>
                            <div class="sec-button-link w_80 flt_right" data-dismiss="modal" mat-dialog-close>Cancel
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
